import { createActionGroup, props } from '@ngrx/store';

export const ProductContextActions = createActionGroup({
  source: 'ProductContext',
  events: {
    set_context: props<{ context: string }>()
  }
});
